import moment from "moment"
import React, { useEffect, useState } from "react"
import { ButtonGroup, Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

const PersonalInfoTab = ({
    customer,
    handleChange
}: {
    customer: Record<string, any>
    handleChange: Function
}) => {
    const { t } = useTranslation()
    const [credited, setCredited] = useState(customer.is_credit_user)
    const [incomingOrderFeature, setIncomingOrderFeature] = useState(customer.show_incoming_orders)
    const [uploadFiles, setUploadFiles] = useState(customer.upload_files)
    const [fullfilmentFeature, setFullfilmentFeature] = useState(customer.show_fullfilment)
    const [template, setTemplate] = useState(customer.template)
    const [active, setActive] = useState(customer.status)

    useEffect(() => {
        setCredited(customer.is_credit_user)
        setActive(customer.status)
        setIncomingOrderFeature(customer.show_incoming_orders)
        setFullfilmentFeature(customer.show_fullfilment)
        setTemplate(customer.template)
        setUploadFiles(customer.upload_files)
    }, [customer?.id])

    function controlFlags(e: any) {
        if (e.target.checked) {
            if (e.target.name === "showIncomingOrders") setIncomingOrderFeature(1)
            if (e.target.name === "showFullfilment") setFullfilmentFeature(1)
            if (e.target.name === "notShowIncomingOrders") setIncomingOrderFeature(0)
            if (e.target.name === "notShowFullfilment") setFullfilmentFeature(0)
            if (e.target.name === "template_amazon") setTemplate(1)
            if (e.target.name === "template_amazon_wo_lm") setTemplate(4)
            if (e.target.name === "template_noon") setTemplate(2)
            if (e.target.name === "uploadFiles") setUploadFiles(1)
            if (e.target.name === "notUploadFiles") setUploadFiles(0)
        }
        handleChange(e)
    }
    return (
        <>
            <div className="card_container row  hidden-md-up mx-0 py-3">
                <Row className="mx-0 my-2 justify-content-between">
                    <Col xs={12} sm={12} md={5} lg={5} className="label">
                        <div className="title mb-4 text-muted">{t("Personal Information")}</div>
                        <Row className="mb-4">
                            <Col xs={4}>
                                <Form.Label className="required">{t("First Name")}</Form.Label>
                            </Col>
                            <Col xs={8}>
                                <Form.Control
                                    type="text"
                                    placeholder={t("First Name")}
                                    name="fname"
                                    required={true}
                                    value={customer?.fname}
                                    onChange={(e: any) => handleChange(e)}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={4}>
                                <Form.Label className="required">{t("last Name")}</Form.Label>
                            </Col>
                            <Col xs={8}>
                                <Form.Control
                                    type="text"
                                    placeholder={t("Last Name")}
                                    name="lname"
                                    required={true}
                                    value={customer?.lname}
                                    onChange={(e: any) => handleChange(e)}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={4}>
                                <Form.Label className="required">{t("Email")}</Form.Label>
                            </Col>
                            <Col xs={8}>
                                <span>{customer?.email}</span>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={4}>
                                <Form.Label className="required">{t("Password")}</Form.Label>
                            </Col>
                            <Col xs={8}>
                                <span>**************</span>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={4}>
                                <Form.Label className="required">{t("Status")}</Form.Label>
                            </Col>
                            <Col xs={8}>
                                <ButtonGroup className="mx-3 d-flex justify-content-between">
                                    <div className="mx-2">
                                        <input
                                            type="radio"
                                            name="active"
                                            className="text-start"
                                            onChange={() => setActive(1)}
                                            checked={active === 1 ? true : false}
                                        />
                                        <span className="value mx-2">{t("Active")}</span>
                                    </div>
                                    <div className="mx-2">
                                        <input
                                            type="radio"
                                            name="inactive"
                                            className="text-start"
                                            onChange={() => setActive(0)}
                                            checked={active === 0 ? true : false}
                                        />
                                        <span className="value mx-2">{t("Inactive")}</span>
                                    </div>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={5} lg={5} className="label">
                        <div className="title mb-4 text-muted">{t("otherOptions")}</div>
                        {/*<Row className="mb-4">
                            <Col xs={6}>
                                <Form.Label className="required">
                                    {t("By pass payment")}
                                </Form.Label>
                            </Col>
                            
                             <Col xs={6}>
                                <ButtonGroup className="mx-3 d-flex justify-content-between">
                                    <div>
                                        <input
                                            type="radio"
                                            name="credited"
                                            onChange={() => setCredited(1)}
                                            checked={credited === 1 ? true : false}
                                        />
                                        <span className="value mx-2">
                                            {t("Yes")}
                                        </span>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            name="noncredited"
                                            onChange={() => setCredited(0)}
                                            checked={credited === 0 ? true : false}
                                        />
                                        <span className="value mx-2">
                                            {t("No")}
                                        </span>
                                    </div>
                                </ButtonGroup>
                            </Col>
                        </Row> */}
                        <Row className="mb-4">
                            <Col xs={6}>
                                <Form.Label className="required">{t("Upload files")}</Form.Label>
                            </Col>
                            <Col xs={6}>
                                <ButtonGroup className="mx-3 d-flex justify-content-between">
                                    <div>
                                        <input
                                            type="radio"
                                            name="uploadFiles"
                                            onChange={(e: any) => controlFlags(e)}
                                            checked={uploadFiles === 1 ? true : false}
                                        />
                                        <span className="value mx-2">{t("Yes")}</span>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            name="notUploadFiles"
                                            onChange={(e: any) => controlFlags(e)}
                                            checked={uploadFiles === 0 ? true : false}
                                        />
                                        <span className="value mx-2">{t("No")}</span>
                                    </div>
                                </ButtonGroup>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={6}>
                                <Form.Label className="required">{t("Fulfilment Feature")}</Form.Label>
                            </Col>
                            <Col xs={6}>
                                <ButtonGroup className="mx-3 d-flex justify-content-between">
                                    <div>
                                        <input
                                            type="radio"
                                            name="showFullfilment"
                                            onChange={(e: any) => controlFlags(e)}
                                            checked={fullfilmentFeature === 1 ? true : false}
                                        />
                                        <span className="value mx-2">{t("Yes")}</span>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            name="notShowFullfilment"
                                            onChange={(e: any) => controlFlags(e)}
                                            checked={fullfilmentFeature === 0 ? true : false}
                                        />
                                        <span className="value mx-2">{t("No")}</span>
                                    </div>
                                </ButtonGroup>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={6}>
                                <Form.Label className="required">
                                    {t("Show incoming orders feature")}
                                </Form.Label>
                            </Col>
                            <Col xs={6}>
                                <ButtonGroup className="mx-3 d-flex justify-content-between">
                                    <div>
                                        <input
                                            type="radio"
                                            name="showIncomingOrders"
                                            onChange={(e: any) => controlFlags(e)}
                                            checked={incomingOrderFeature === 1 ? true : false}
                                        />
                                        <span className="value mx-2">{t("Yes")}</span>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            name="notShowIncomingOrders"
                                            onChange={(e: any) => controlFlags(e)}
                                            checked={incomingOrderFeature === 0 ? true : false}
                                        />
                                        <span className="value mx-2">{t("No")}</span>
                                    </div>
                                </ButtonGroup>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={6}>
                                <Form.Label className="required">{t("Template")}</Form.Label>
                            </Col>
                            <Col xs={6}>
                                <ButtonGroup className="mx-3 d-flex justify-content-between">
                                    <Row>
                                        <Col xs={12} className="mb-2">
                                            <div>
                                                <input
                                                    type="radio"
                                                    name="template_amazon"
                                                    onChange={(e: any) => controlFlags(e)}
                                                    checked={template === 1 ? true : false}
                                                    disabled={!incomingOrderFeature}
                                                />
                                                <span className="value mx-2">{t("Amazon Seller")}</span>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="my-2">
                                            <div>
                                                <input
                                                    type="radio"
                                                    name="template_amazon_wo_lm"
                                                    onChange={(e: any) => controlFlags(e)}
                                                    checked={template === 4 ? true : false}
                                                    disabled={!incomingOrderFeature}
                                                />
                                                <span className="value mx-2">
                                                    {t("Amazon shipments without L.M")}
                                                </span>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="my-2">
                                            <div>
                                                <input
                                                    type="radio"
                                                    name="template_noon"
                                                    onChange={(e: any) => controlFlags(e)}
                                                    checked={template === 2 ? true : false}
                                                    disabled={!incomingOrderFeature}
                                                />
                                                <span className="value mx-2">{t("Others")}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mx-0 my-2">
                    <Col xs={12} sm={12} md={5} lg={5}>
                        <div className="title mb-4 text-muted">{t("Extended Membership plan")}</div>
                        <Row className="mb-4">
                            <Col xs={4}>
                                <Form.Label className="required">{t("Start Date")}</Form.Label>
                            </Col>
                            <Col xs={8}>
                                <Form.Control
                                    type="date"
                                    placeholder={t("Start Date")}
                                    name="start_date"
                                    readOnly
                                    value={moment(customer?.PlanTransaction?.created_at).format("YYYY-MM-DD")}
                                />
                            </Col>
                        </Row>
                        {customer?.PlanTransaction && (
                            <Row className="mb-4">
                                <Col xs={4}>
                                    <Form.Label className="required">{t("End Date")}</Form.Label>
                                </Col>
                                <Col xs={8}>
                                    <Form.Control
                                        type="date"
                                        placeholder={t("End Date")}
                                        name="end_date"
                                        required={true}
                                        value={customer?.plan_expiry}
                                        onChange={(e: any) => handleChange(e)}
                                    />
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default PersonalInfoTab
